import { AxiosError, HttpStatusCode, isAxiosError } from 'axios';

const BACKEND_UNAVAILABLE_STATUSES: number[] = [
  HttpStatusCode.BadGateway,
  HttpStatusCode.ServiceUnavailable,
  HttpStatusCode.GatewayTimeout,
];

export const isBackendUnavailableError = (error: unknown): boolean => {
  if (!isAxiosError(error) || error.code === AxiosError.ERR_CANCELED) {
    return false;
  }

  return !error.response || BACKEND_UNAVAILABLE_STATUSES.includes(error.response.status);
};
